import React from 'react';
import { Helmet } from 'react-helmet-async';
import manikchandLogo from '../../assets/images/manikchand_Logo.svg';

const DashboardPageHelmet: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Namasteji Manikchand | Premium Pan Masala Online in India</title>
        <meta
          name='description'
          content='Explore Namasteji Manikchand Pan Masala—crafted with authentic Indian flavors and premium ingredients. Discover rich taste, freshness, and quality in every pack'
        />
        <meta
          name='keywords'
          content='
          Namasteji Manikchand Pan Masala,
          Namasteji Pan Masala,
          Manikchand Pan Masala,
          India Pan Masala,
          Namasteji Masala,
          Premium Pan Masala Online,
          Namasteji box,
          Namasteji Manikchand box,
          Namasteji Manikchand pack,
          Best Pan masala,
          pan masala price,
          manikchand pan masala flavor'
        />

        <link rel='canonical' href='https://globalmanikchand.in/' />
        <meta
          property='og:description'
          content='Experience the legacy of Manikchand with Namasteji Pan Masala — India’s premium choice for flavor, freshness, and excellence. Taste the best in every box.'
        />
        {/* <meta property='og:image' content='https://globalmanikchand.in/home_page_img_1.svg' /> */}
        <meta property='og:image' content={window.location.origin + manikchandLogo} />
        <meta property='og:title' content='Namasteji Manikchand Pan Masala – Finest Blend of Tradition & Taste' />
        <meta property='og:type' content='website' />
        <meta property='og:url' content='https://globalmanikchand.in/' />
        <meta property='og:site_name' content='Namasteji Manikchand' />
        <meta property='og:locale' content='en_IN' />

        {/* Twitter Card */}
        {/* <meta name='twitter:card' content='https://globalmanikchand.in/home_page_img_1.svg' /> */}
        <meta name='twitter:card' content={window.location.origin + manikchandLogo} />
        <meta name='twitter:title' content='Namasteji Manikchand Pan Masala – Finest Blend of Tradition & Taste' />
        <meta
          name='twitter:description'
          content='Experience the legacy of Manikchand with Namasteji Pan Masala — India’s premium choice for flavor, freshness, and excellence. Taste the best in every box.'
        />
        {/* <meta name='twitter:image' content='https://globalmanikchand.in/home_page_img_1.svg' /> */}
        <meta name='twitter:image' content={window.location.origin + manikchandLogo} />
        <meta name='twitter:site' content='@NamastejiManikchand' />
      </Helmet>
    </>
  );
};

export default DashboardPageHelmet;
